import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-snapshot-chartsparent',
  templateUrl: './snapshot-chartsparent.component.html',
  styleUrls: ['./snapshot-chartsparent.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})



export class SnapshotChartsparentComponent {
  @Input() brandSelected:any="";//only for trendline 2 set up for custom snapshot
  @Input() metricSelected:any=""; //only for trendline 2 set up for custom snapshot
  @Input() gridTempleteColumns:any;
  @Input() isOutput=false;
  @Input() chart: any = '';
  @Input() id: number | undefined;
  @Input() height: any;
  @Input() data: any;
  @Input() customData: any;
  @Input() popUp: any;
  @Input() WidgetDetails: any;
  @Input() sort: any;
  @Input() Top10Toggle: any;
  @Input() DataLabelOn: any;
  @Input() snapProduct:string='';
  @Input() widgetCount:any;
  @Input() enableDataBars: boolean = false;
  @Input() widgetName: string = '';
  x: number = 0;
  private dataSubject = new BehaviorSubject<any>(null);
  
  ngOnChanges(changes: SimpleChanges) {
  //   if (changes) {
  //     this.renderChart();
  //   }
   }

  //ngOnChanges(changes: SimpleChanges) {
    // if (changes['chart'] || changes['id'] || changes['data']) {
    //   if (changes['chart'].currentValue == '05 Pie') {
    //     

    //     this.x = 1;
    //   } else {
    //     

    //     this.x = 2;
    //   }
    // }
  //}

  //ngOnInit() {
    
  //}

  // renderChart() {
  //   // this.chart="Pie-05"
  //   if(this.chart=='05 Pie'){
  //     this.x=1;
  //   }
  //   else{
  //     this.x=2
  //   }
  // }
}
